/* eslint-disable no-underscore-dangle */
/* eslint-disable vars-on-top */
/* eslint-disable max-len */
/* eslint-disable indent */
'use strict';

/**
 * Show a spinner inside a given element
 * @param {element} $target - Element to block by the veil and spinner.
 *                            Pass body to block the whole page.
 */
function addSpinner($target) {
    var $veil = $('<div class="veil"><div class="underlay"></div></div>');
    $veil.append(
        '<div class="spinner" tabindex="-1" aria-label="Loading"><div class="dot1"></div><div class="dot2"></div><div class="dot3"></div></div>'
    );
    if ($target.get(0).tagName === 'IMG') {
        $target.after($veil);
        $veil.css({ width: $target.width(), height: $target.height() });
        if ($target.parent().css('position') === 'static') {
            $target.parent().css('position', 'relative');
        }
    } else {
        $target.append($veil);
        if ($target.css('position') === 'static') {
            $target.parent().css('position', 'relative');
            $target.parent().addClass('veiled');
        }
        if ($target.get(0).tagName === 'BODY') {
            $veil.find('.spinner').css('position', 'fixed');
        }
    }
    $veil.click(function (e) {
        e.stopPropagation();
    });
}

/**
 * Remove existing spinner
 * @param  {element} $veil - jQuery pointer to the veil element
 */
function removeSpinner($veil) {
    if ($veil.parent().hasClass('veiled')) {
        $veil.parent().css('position', '');
        $veil.parent().removeClass('veiled');
    }
    $veil.off('click');
    $veil.remove();
}

/**
 * element level spinner:
 */
$.fn.spinner = function () {
    var $element = $(this);
    var Fn = function () {
        this.start = function () {
            if ($element.length) {
                addSpinner($element);
            }
        };
        this.stop = function () {
            if ($element.length) {
                var $veil = $('.veil');
                removeSpinner($veil);
            }
        };
    };
    return new Fn();
};

/**
 * page-level spinner:
 * @param {boolean} manageFocus - if set to true, sets focus on the spinner while visible, then returns focus to last clicked element when spinner stops
 */
$.spinner = function (manageFocusParam) {
    var manageFocus = manageFocusParam === undefined ? true : manageFocusParam;
    var Fn = function () {
        this.start = function () {
            if (manageFocus) {
                window._lastFocus = document.activeElement;
            }
            var $target = $('body');
            addSpinner($target);
            if (manageFocus) {
                $('.spinner', $target).focus();
            }
        };
        this.stop = function () {
            removeSpinner($('.veil'));
            if (window._lastFocus && manageFocus) {
                var elementId = $(window._lastFocus).attr('id');
                // Use getElementById (exact id match) rather than a jQuery '#'-selector: the id can
                // contain characters like '&' or '.' that are invalid/meaningful in selector syntax.
                var elementToFocus = elementId ? document.getElementById(elementId) : window._lastFocus;
                if (elementToFocus) {
                    $(elementToFocus).focus();
                }
                window._lastFocus = null;
            }
        };
    };
    return new Fn();
};
